import { createContext, ReactNode, useContext, useMemo } from "react";
import {
    OrganizationActivityPerson,
    useOrganizationActivityPeople,
} from "./useOrganizationActivityPeople";

const OrganizationActivityPeopleByIdContext = createContext<ReadonlyMap<
    number,
    OrganizationActivityPerson
> | null>(null);

/** Builds the org Activity page's id -> person lookup once for every row and the details drawer. */
export const OrganizationActivityPeopleProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const people = useOrganizationActivityPeople();
    const peopleById = useMemo(
        () => new Map(people.map((person) => [person.id, person])),
        [people],
    );

    return (
        <OrganizationActivityPeopleByIdContext.Provider value={peopleById}>
            {children}
        </OrganizationActivityPeopleByIdContext.Provider>
    );
};

export function useOrganizationActivityPeopleById() {
    const peopleById = useContext(OrganizationActivityPeopleByIdContext);
    if (!peopleById) {
        throw new Error(
            "useOrganizationActivityPeopleById must be used within an OrganizationActivityPeopleProvider",
        );
    }
    return peopleById;
}
